import React from 'react';
import '../../less/desktop';
import MenuItem from '../../views/menuItem.c';
import HoverItem from '../../views/hoverItem.c';
import abankIcon from "../../img/new/abank-icon.svg"
import { CSSTransition } from "react-transition-group";
import { HEADER_HOVER_TIMEOUT, loginBtnTypes } from '../../constants';
import SearchInput from '../../views/searchInput.c';
import SegmentedStorybook from '@abank/abank-segmented';
import LogoLink from '../../views/logoLink.c';
import { getMenuConfig } from '../../getMenuConfig';
import InsideMenuItem from '../../views/insideMenuItem.c';
import menuMeta from '../../enums/desktop/menu_meta.json';
import businessAliases from '../../enums/desktop/business_aliases.json';
import individualAliases from '../../enums/desktop/individual_aliases.json';

export default function template() {
  const { active, navigate, activeSub, isSearchPage, isCollapsed, userType, changeUserType, isBusiness, homeUrl, userTypes } = this.props;

  const renderSubMenuItems = (items, alias) =>
    items.map(item => item.target ? (
      <MenuItem
        key={item.title}
        activeSub={activeSub}
        navigate={navigate}
        target={item.target}
        onClick={() => window.open(item.url, item.target)}
      >
        {this.l10n(item.title)}
      </MenuItem>
    ) : (
      <MenuItem
        key={item.title}
        activeSub={activeSub}
        toggleHover={this.toggleHover}
        alias={alias}
        navigate={navigate}
        url={item.url}
        target={item.target}
      >
        {this.l10n(item.title)}
      </MenuItem>
    ));

  const { url: loginUrl, target: loginTarget, text: loginText } =
    isBusiness ? loginBtnTypes.business : loginBtnTypes[active] || loginBtnTypes.default;

  const baseConfig = getMenuConfig();

  const menuConfig = [
    ...baseConfig,
    { alias: 'contacts' },
    { alias: 'branches' },
    { alias: 'businessABusiness' },
  ].map(item => ({
    ...item,
    ...menuMeta[item.alias],
  }));

  const businessMenu = menuConfig.filter(item =>
    businessAliases.includes(item.alias)
  );

  const individualMenu = menuConfig.filter(item =>
    individualAliases.includes(item.alias)
  );

  const menuToRender = isBusiness ? businessMenu : individualMenu;

  const renderHoverItem = (item) => {
    if (!item.columns) {
      return (
        <MenuItem 
          key={item.alias}
          className="title" 
          active={active} 
          alias={item.alias} 
          navigate={navigate} 
          url={item.url} 
          top
        >
          {this.l10n(item.title)}
        </MenuItem>
      )
    }
    return (
      <HoverItem key={item.alias} className="title-wrap" alias={item.alias} toggleHover={this.toggleHover} hover={this.state[item.alias]}>
        <MenuItem 
          className="title" 
          active={active}
          alias={item.alias} 
          navigate={navigate} 
          toggleHover={this.toggleHover} 
          url={item.url} 
          top 
        >
          {this.l10n(item.title)}
        </MenuItem>
        <InsideMenuItem 
          menu={item} 
          bannerCloseHandler={() => this.toggleHover(false, item.alias)} 
          active={item.alias} 
          navigate={navigate} 
          renderSubMenuItems={renderSubMenuItems}
        />
      </HoverItem>
    );
  };

  return (
    <header className={`module-header-desktop ${isCollapsed ? "collapsed" : ""}`}>
      <CSSTransition in={!isCollapsed} timeout={250} classNames="fly-user-type" unmountOnExit>
        <div className="user-type">
          <SegmentedStorybook 
            collapsed={false} 
            tabs={userTypes} 
            tab={userType} 
            toggle={changeUserType} 
            leadIcon={false} 
          />
        </div>
      </CSSTransition>
      <CSSTransition in={!isCollapsed} timeout={HEADER_HOVER_TIMEOUT} classNames="fly-desktop-header-top" unmountOnExit>
        <div className="desktop-header-top">
          <div className="container">
            <div className="desktop-header-top__left left-desktop-header-top">
              <LogoLink homeUrl={homeUrl} navigate={navigate} className="left-desktop-header-top__logo"/>
              {!isSearchPage && (
                <SearchInput navigate={navigate} className="left-desktop-header-top__input"/>
              )}
            </div>
            <div className="desktop-header-top__right right-desktop-header-top">
              <a className="right-desktop-header-top__abank24" href={loginUrl} target={loginTarget} onClick={loginTarget === '_self' ? e => navigate(loginUrl, e) : undefined}>
                <div className="right-desktop-header-top__image"><img src={abankIcon} alt="abank icon" /></div>
                <div className="right-desktop-header-top__text">{this.l10n(loginText)}</div>
              </a>
            </div>
          </div>
        </div>
      </CSSTransition>
      <div className={`container desktop-header-bottom-container${isCollapsed ? ' collapsed' : ''}`}>
        <div className="desktop-header-bottom-left">
          <LogoLink homeUrl={homeUrl} navigate={navigate} className="desktop-header-bottom__logo"/>
          {menuToRender.map(renderHoverItem)}
        </div>
        {(!isSearchPage && isCollapsed) && (
          <div className="desktop-header-bottom__right right-desktop-header-bottom">
            <SearchInput navigate={navigate} className="right-desktop-header-bottom__input"/>
          </div>
        )}
      </div>
    </header>
  );
}
